import {
  getVehicleTypeValue,
  getSalutationValue,
  getPhoneValue,
  getYesNoValue,
  getLastNameValue,
  getFirstNameValue,
  padPolicyNumber,
  getDateValueProxy,
  arrayIncludesKeyAndValueProxy,
  getCountryCode,
  getLicenseNumber,
  arrayIncludesValueProxy,
  arrayIncludesAnyValueProxy,
} from '../claimData.helpers';
import {
  getPersonDamageItemDamagesValueProxy,
  getAnimalDamageCircumstancesValueProxy,
} from './claimData.helpers';
import { claimsKeys, getCarMapKey, userTypes } from '../../../helpers/formData/formData';

export default {
  'event-circumstances_day': {
    date: [claimsKeys.DATE, getDateValueProxy],
  },
  'event-circumstances_location': {
    location: claimsKeys.LOCATION,
    country: [claimsKeys.COUNTRY_CODE, getCountryCode],
  },
  'animal-damage_circumstances': [claimsKeys.CIRCUMSTANCES, getAnimalDamageCircumstancesValueProxy],
  'animal-damage_circumstance-description': claimsKeys.FURTHER_INFORMATION,
  'animal-damage_who-what-has-suffered': {
    'personal-injury': [claimsKeys.thirdParty.PERSONAL_INJURY, arrayIncludesValueProxy('personal-injury')],
    'vehicle-damage': [claimsKeys.thirdParty.VEHICLE_DAMAGE, arrayIncludesValueProxy('vehicle-damage')],
    // The sam key as we have for item-damage
    // adhoc decision to send 'j' if any is selected of furniture-damage or animal-injury
    // 'furniture-damage': [claimsKeys.thirdParty.ITEM_DAMAGE, arrayIncludesValueProxy('furniture-damage')],
    'animal-injury':
      [claimsKeys.thirdParty.ITEM_DAMAGE, arrayIncludesAnyValueProxy(['furniture-damage', 'animal-injury'])],
  },
  // Personal
  'animal-damage_specify-personal-injury': claimsKeys.thirdParty.PERSONAL_INJURIES,
  // Item
  'animal-damage_specify-item-damage_borrowed': [claimsKeys.thirdParty.OBJECTS_LENDING, getYesNoValue],
  'animal-damage_specify-item-damage_item-damage': [
    claimsKeys.thirdParty.ITEM_INJURIES, getPersonDamageItemDamagesValueProxy,
  ],
  // Vehicle
  'animal-damage_specify-vehicle-damage_vehicle-type': [claimsKeys.thirdParty.VEHICLE_TYPE, getVehicleTypeValue],
  'animal-damage_specify-vehicle-damage_license-number': [
    claimsKeys.thirdParty.LICENSE_NUMBER,
    getLicenseNumber,
  ],
  'animal-damage_specify-vehicle-damage_car-map': {
    describeDamage: claimsKeys.thirdParty.DESCRIBE_DAMAGE,
    'front-left': [
      getCarMapKey('front-left', userTypes.THIRD_PARTY),
      arrayIncludesKeyAndValueProxy('carMap', 'front-left'),
    ],
    'front-middle': [
      getCarMapKey('front-middle', userTypes.THIRD_PARTY),
      arrayIncludesKeyAndValueProxy('carMap', 'front-middle'),
    ],
    'front-right': [
      getCarMapKey('front-right', userTypes.THIRD_PARTY),
      arrayIncludesKeyAndValueProxy('carMap', 'front-right'),
    ],
    'middle-left': [
      getCarMapKey('middle-left', userTypes.THIRD_PARTY),
      arrayIncludesKeyAndValueProxy('carMap', 'middle-left'),
    ],
    'middle-part': [
      getCarMapKey('middle-part', userTypes.THIRD_PARTY),
      arrayIncludesKeyAndValueProxy('carMap', 'middle-part'),
    ],
    'middle-right': [
      getCarMapKey('middle-right', userTypes.THIRD_PARTY),
      arrayIncludesKeyAndValueProxy('carMap', 'middle-right'),
    ],
    'back-left': [
      getCarMapKey('back-left', userTypes.THIRD_PARTY),
      arrayIncludesKeyAndValueProxy('carMap', 'back-left'),
    ],
    'back-middle': [
      getCarMapKey('back-middle', userTypes.THIRD_PARTY),
      arrayIncludesKeyAndValueProxy('carMap', 'back-middle'),
    ],
    'back-right': [
      getCarMapKey('back-right', userTypes.THIRD_PARTY),
      arrayIncludesKeyAndValueProxy('carMap', 'back-right'),
    ],
  },
  'animal-damage_specify-vehicle-damage_bike-other': claimsKeys.thirdParty.DESCRIBE_DAMAGE,
  // Animal
  'animal-damage_specify-animal-injury': claimsKeys.thirdParty.ANIMAL_INJURIES,

  'policy-holder_policy-number': [claimsKeys.POLICY_NUMBER, padPolicyNumber],
  'policy-holder_contact': {
    who: [claimsKeys.owner.SALUTATION, getSalutationValue],
    firstName: [claimsKeys.owner.FIRST_NAME, getFirstNameValue],
    lastName: [claimsKeys.owner.LAST_NAME, getLastNameValue],
    phoneNumber: [claimsKeys.owner.PHONE, getPhoneValue],
    email: claimsKeys.owner.EMAIL,
  },
  'third-person_contact': {
    who: [claimsKeys.thirdParty.SALUTATION, getSalutationValue],
    firstName: [claimsKeys.thirdParty.FIRST_NAME, getFirstNameValue],
    lastName: [claimsKeys.thirdParty.LAST_NAME, getLastNameValue],
    phoneNumber: [claimsKeys.thirdParty.PHONE, getPhoneValue],
  },
  'third-person_location': {
    address: claimsKeys.thirdParty.ADDRESS,
    postCode: claimsKeys.thirdParty.POST_CODE,
    city: claimsKeys.thirdParty.CITY,
    country: [claimsKeys.thirdParty.COUNTRY_CODE, getCountryCode],
  },
  settlement: [claimsKeys.SETTLEMENT, getYesNoValue],
};

// ToDo: Add animal-damage_was-collosion here
